import { EventScoreboard } from '@frontend/sports/betting-offer/feature/model';

import { ScoreboardPairGameViewModel } from './pair-game-scoreboard.viewmodel';
import { SnookerScoreboardStats } from './scoreboard-stats';

export class SnookerScoreboardViewModel extends ScoreboardPairGameViewModel {
    stats: SnookerScoreboardStats;

    constructor() {
        super();
        this.stats = new SnookerScoreboardStats();
        this.bestOf = 0;
    }

    protected override fillFromScoreboard(scoreboard: EventScoreboard): void {
        super.fillFromScoreboard(scoreboard);
        this.stats.fillSnookerStats(scoreboard);
        this.bestOf = scoreboard.bestOf;
    }

    override updateFromScoreboard(scoreboard: EventScoreboard): void {
        super.updateFromScoreboard(scoreboard);
        this.stats.fillSnookerStats(scoreboard);
        this.bestOf = scoreboard.bestOf;
    }
}
